import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'src/app/state/store';

export const getShowCheckoutTransferModal = (state: RootState) => {
  return state?.checkoutTransferModal?.show;
};

const getDisplayModalState = (state: RootState) => state.displayModal;

export const getIsNewArchivedPageModalBeingShown = createSelector(
  getDisplayModalState,
  displayModalState => displayModalState?.newArchivedPage?.showModal
);
